import AturEkspedisi from './AturEkspedisi.vue'

export default AturEkspedisi
